import { render, staticRenderFns } from "./CircleTagList.vue?vue&type=template&id=1b53b15b&scoped=true"
import script from "./CircleTagList.vue?vue&type=script&lang=js"
export * from "./CircleTagList.vue?vue&type=script&lang=js"
import style0 from "./CircleTagList.vue?vue&type=style&index=0&id=1b53b15b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b53b15b",
  null
  
)

export default component.exports